export default __webpack_public_path__ + "static/media/docfile.9066a9db.svg";